import React from 'react'
import HRLocationSelect from './HRLocationSelect'
import MultiSelect from './MultiSelect'
import { IHRLocation } from '@api/types'

interface MultiHRLocationSelectProps {
  values: IHRLocation[]
  onChange: (hrLocations: IHRLocation[]) => void
}

export default function MultiHRLocationSelect({ values, onChange }: MultiHRLocationSelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <MultiSelect
      title="HR Locations"
      values={values.map((v) => (
        <span key={v.id}>{v.location}</span>
      ))}
      select={
        <HRLocationSelect
          multi
          value={null}
          btnText="Add"
          itemDisabled={(item) => !!values.find(({ id }) => item.id === id)}
          onChange={(hrLoc) =>
            values.find(({ id }) => id === hrLoc.id)
              ? onChange(values.filter(({ id }) => id !== hrLoc.id))
              : onChange([...values, hrLoc])
          }
          {...{ buttonProps }}
        />
      }
      onRemove={(locationId) => onChange(values.filter((av) => av.id !== locationId))}
    />
  )
}
